import {AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, ViewChild, ViewContainerRef} from "@angular/core";
import {AppService} from "@api";
import {FiltroModel} from "@componentes/Filtros/Filtro.model";
import {FiltrosComponent} from "@componentes/Filtros/Filtros.component";
import {TipoFiltroEnum} from "@componentes/Filtros/Filtros.enum";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum, DialogoEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {Plantilla} from "@modelo/proceso/Plantilla.model";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {PlantillaPreguntaFormComponent} from "./plantillapreguntaForm.component";
import {Colaborador} from "@modelo/catalogo/Colaborador.model";

@Component({
    selector: 'plantillapregunta',
    templateUrl: './plantillapregunta.component.html',
    styleUrls: ['./plantillapregunta.component.scss']
})


export class PlantillaPreguntaComponent implements AfterViewInit {
    public prueba: Colaborador;
    public entidad: Plantilla;
    public errorActivo!: boolean;
    public animacion!: string;
    public abierto!: boolean;

    errornivel: boolean
    copia: boolean;
    infocopia: any[];
    selectedRows: any[];
    idplantillaacopiar!: number;

    SelDepartamento: any[];
    SelEvaluador: any[];
    SelNivel: any[];
    SelGrados: any[];
    SelTipoClase: any[] = [];
    SelTipoPlantilla: any[] = [];
    dataTable!: Array<any>

    consulta!: boolean;
    ver!:boolean;
    @ViewChild("plantillaFormulario", {read: ViewContainerRef}) plantillaFormulario!: ViewContainerRef;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    parametro: boolean = false;

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.uriApi = "planeacion/plantilla/buscar";
        this.entidad = new Plantilla();
        this.prueba = new Colaborador();
        this.copia = false;
        this.errornivel = false;

        this.infocopia = [];
        this.SelDepartamento = [];
        this.selectedRows = [];
        this.SelEvaluador = [];
        this.SelNivel = [];
        this.SelGrados = [];

        this.GenerarFiltros();
    }


    ngAfterViewInit() {
        this.SetTipoPlantilla();
        this.SetEvaluadorFiltro();
        this.SetNivelFiltro();
        this.SetParametro();
    }

    permisosLoaded() {

        // if (this.sistemaService.permisos.edicionespecial) {
        //     this.SetDepartamentoFiltro();
        // } else {
        //     this.SetDepartamentoUsuarioFiltro()
        // }
    }

    //Genera el filtro para buscar las plantillas
    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Descripción',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'descripcion'
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDownMulti,
                    Valor: [],
                    Titulo: 'Evaluadores',
                    DisplayValor: 'nombre',
                    ValorName: 'evaluadorid',
                    Opciones: this.SelEvaluador,
                    Propiedad: "evaluadorid",
                    Obligatorio: false,
                    Buscar: false,
                })
        );
        filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.DropDown,
                  Titulo: 'Tipo plantilla',
                  DisplayValor: 'nombre',
                  ValorName: 'tipoplantillaid',
                  Opciones: this.SelTipoPlantilla,
                  Propiedad: "tipoplantillaid",
                  Obligatorio: false,
                  Buscar: false,
              })
      );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Nivel',
                    DisplayValor: 'nombre',
                    ValorName: 'nivelid',
                    Opciones: this.SelNivel,
                    Propiedad: 'nivelid',
                    Obligatorio: false,
                    Buscar: false,
                    Suscripcion: new EventEmitter()
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDownMulti,
                    Valor: [],
                    Titulo: 'Grados',
                    DisplayValor: 'nombre',
                    ValorName: 'gradoid',
                    Opciones: this.SelGrados,
                    Propiedad: 'gradoid',
                    Obligatorio: false,
                    Buscar: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Activo',
                    DisplayValor: 'nombre',
                    ValorName: 'valor',
                    Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                    Propiedad: "activo",
                    Obligatorio: false,
                    Buscar: false
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    //Trae las evaluador para el filtro de las plantilla
    SetEvaluadorFiltro() {
        this.appService.Get("catalogo/evaluador").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEvaluador = res.data;
                this.SelEvaluador = this.SelEvaluador.filter(x=>x.evaluadorid != 5);
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'evaluadorid');
                if (filtro) {
                    filtro.Opciones = this.SelEvaluador;
                }
            }
        });
    }

    //Trae las nivel para el filtro de las plantilla
    SetNivelFiltro() {
        this.appService.Get("catalogo/nivel").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelNivel = res.data;
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'nivelid');
                if (filtro) {
                    filtro.Opciones = this.SelNivel;
                    filtro.Suscripcion.subscribe((v: number) => {
                        this.SetGradoFiltro(v);
                    })
                }
            }
        });
    }

    //Traer la informacion de grado para el filtro de plantilla
    SetGradoFiltro(nivelid: number) {
        let filtro = this.filtrosComponent.filtrosSeleccionados.find(x => x.ValorName == 'gradoid');
        if (filtro) {
            filtro.Valor = [];
            if (!nivelid) {
                this.SelGrados = [];
                filtro.Opciones = this.SelGrados;
                return;
            }
            this.appService.Get("catalogo/grado/" + nivelid).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelGrados = res.data;
                    if (filtro) {
                        filtro.Opciones = this.SelGrados;
                    }
                }
            });
        }
    }

    //Trae la informaicon para del dropbox de la modal agregar plantilla
    SetGrado(nivelid: number) {
        if (nivelid) {
            this.appService.Get("catalogo/grado/" + nivelid).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelGrados = res.data;
                    this.entidad.gradoid = [];
                }
            });
        } else {
            this.entidad.gradoid = [];
            this.SelGrados = [];
        }
    }

    SetTipoPlantilla(){
        this.appService.Post("planeacion/plantilla/tipoplantilla",{}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.SelTipoPlantilla = res.data;
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'tipoplantillaid');
                if (filtro) {
                    filtro.Opciones = this.SelTipoPlantilla;
                }
            }
        })
    }

    SetParametro(){
      this.appService.Get("catalogo/parametro/FiltroAutoPlantillaPreguntas").then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              let parametro = res.data.parametro;
              this.parametro = parametro?.valor == 1;
          }
      })
  }

    //Manda la informacion a la tabla correspondiente
    SetDatos(data: any) {
        if (this.sistemaService.permisos.edicionespecial) {
            this.dataTable = data;
        } else {
            this.dataTable = data;
            this.dataTable = this.dataTable.filter(dato => dato.departamentotodos == false);
        }
    }

    //Elimina la plantilla seleccionada
    Eliminar(e: any) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("planeacion/plantilla/" + e.plantillaid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }

    //Genera la modal para agregar nuevas plantillas
    // Modal() {
    //     this.entidad = new Plantilla()
    //     this.animacion = this.sistemaService.animacionAbirModal;
    //     this.abierto = true;
    //     this.copia = false
    //     this.errorActivo = false;
    // }

    //Cierra la modal de agregar plantillas
    // CerrarModal() {
    //     //this.entidad = new Criterio();
    //     this.animacion = this.sistemaService.animacionCerrarModal;
    //     this.entidad = new Plantilla()
    //     this.copia = false
    //     this.errornivel = false;
    //     setTimeout(() => {
    //         this.abierto = false;
    //     }, 310);
    // }

    //Valida los campos obligatorios para agregar plantillas
    // Validar(): any {
    //     this.errorActivo = true;
    //     if (!this.entidad.descripcion) {
    //         return "Se tiene que escribir la descripción de la plantilla"
    //     }
    //     if (!this.entidad.departamentoid && !this.entidad.departamentotodos) {
    //         return "Se requiere seleccionar un departamento"
    //     }
    //     if (!this.entidad.tipoplantillaid) {
    //         return "Se requiere seleccionar el tipo de la plantilla"
    //     }
    //     if (this.entidad.evaluadorid.length == 0) {
    //         return "Se requiere seleccionar mínimo un evaluador"
    //     }
    //     if (this.entidad.evaluadorid.length > 0) {
    //         for (let evaluador of this.entidad.evaluadorid) {
    //             if (evaluador == 2 || evaluador == 3 || evaluador == 4) {
    //                 if (!this.entidad.nivelid) {
    //                     return "Se requiere seleccionar el nivel"
    //                 }
    //             }
    //         }
    //     }
    //     if (this.entidad.nivelid) {
    //         if (this.entidad.gradoid.length == 0) {
    //             return "Se requiere seleccionar mínimo un grado"
    //         }
    //     }
    //     return true
    // }

    Evaluador(e: any) {
        if (e.length > 0) {
            let resultado = e.find((x: any) => x == 2 || x == 3 || x == 4);
            if (resultado) {
                this.errornivel = true
            } else {
                this.errornivel = false;
            }
        } else {
            this.errornivel = false;
        }
    }

    //Guarda una plantilla nueva
    // Guardar() {
    //     let plantillapregunta = {};
    //     if (this.entidad.departamentoid == 0) {
    //         this.entidad.departamentotodos = 1;
    //     } else {
    //         this.entidad.departamentotodos = 0;
    //     }
    //     let respuesta = this.Validar();
    //     let data = new Plantilla(this.entidad)
    //     if (!this.copia) {
    //         if (respuesta === true) {
    //             this.appService.Post("planeacion/plantilla", data).then(res => {
    //                 if (res.status == RespuestaEstatusEnum.Success) {
    //                     this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
    //                     this.mensajeService.Alerta(AlertaEnum.Success, res.message);
    //                     this.CerrarModal();
    //                     this.Formulario(2, res.data.entidad[0]);
    //                 }
    //             });
    //         } else {
    //             this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
    //         }
    //     } else {
    //         if (respuesta === true) {
    //             this.appService.Post("planeacion/plantilla", data).then(res => {
    //                 if (res.status == RespuestaEstatusEnum.Success) {
    //                     let id = res.data.id;
    //                     this.appService.Post("planeacion/plantilla/plantillaporpregunta", {plantillaid: this.idplantillaacopiar}).then(res => {
    //                         if (res.status == RespuestaEstatusEnum.Success) {
    //                             let dataplantillapregunta = [];
    //                             for (let plantilla of res.data) {
    //                                 if (plantilla.obligatorio) {
    //                                     plantillapregunta = {"plantillaid": id, "preguntaid": plantilla.preguntaid, "obligatorio": plantilla.obligatorio}
    //                                 } else {
    //                                     plantillapregunta = {"plantillaid": id, "preguntaid": plantilla.preguntaid, "obligatorio": false}
    //                                 }
    //                                 dataplantillapregunta.push(plantillapregunta);
    //                             }
    //                             let datoplantillapregunta = {"plantillaid": id, "listplantillapregunta": dataplantillapregunta}
    //                             this.appService.Post("planeacion/plantilla/plantillaporpreguntaguardar", datoplantillapregunta).then(res => {
    //                                 if (res.status == RespuestaEstatusEnum.Success) {
    //                                     this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
    //                                     this.mensajeService.Alerta(AlertaEnum.Success, res.message);
    //                                     this.CerrarModal();
    //                                     this.copia = false;
    //                                     this.selectedRows = [];
    //                                 }
    //                             });
    //                         }
    //                     });
    //                 }
    //             });
    //         } else {
    //             this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
    //         }
    //     }
    // }

    //Genera y guarda una copia de una plantilla seleccionada
    GuardarCopia() {
        if (this.selectedRows.length > 0) {
        let opciones = this.sistemaService.GetOpcionesConfirmar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Advertencia se realizarán copias de varias plantillas <br> ¿Desea Continuar?', opciones).then(res => {
            if (res == 1) {
                    this.appService.Post("planeacion/plantilla/copia", this.selectedRows).then(res => {
                        if (res.status == RespuestaEstatusEnum.Success) {
                            this.selectedRows = []
                            this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                        }
                    })
                }
            })
        }else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Selecciona una plantilla para realizar una copia");
        }
    }

    //Formulario para mandar al Forms de edicion y visualizacion de la informacion mas detallada de la plantilla seleccionada
    Formulario(accionid: number, entidad: any = new Plantilla()) {
        let accion: string = ""
        switch (accionid) {
            case 1:
                accion = "Ver";
                break;
            case 2:
                accion = "Editar";
                break;
            case 3:
                accion = "Nuevo";
                break;
        }
        this.cargarContenedorFormulario({accionid: accionid, accion: accion, entidad: entidad});
    }

    //Carga el nuevo contenedor del Forms
    cargarContenedorFormulario(data: {accionid: number, accion: string, entidad: any}) {
        this.consulta = true;
        this.plantillaFormulario.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(PlantillaPreguntaFormComponent);
        var ref: ComponentRef<any> = this.plantillaFormulario.createComponent(factory);
        ref.instance.accion = {accionid: data.accionid, accion: data.accion};
        ref.instance.entidadplantilla = data.entidad;
        ref.instance.parametro = this.parametro;
        ref.instance.output.subscribe((cambio: boolean) => {
            if (cambio) {
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
            this.consulta = false;
            ref.destroy();
        });
    }

}
